// @module BRListrak
define('BRListrak.View', ['BRListrak.tpl', 'BRListrak.SS2Model', 'Backbone'], function (
	BRListrak_tpl,

	BRListrakSS2Model,

	Backbone
) {
	'use strict';

	// @class BRListrak.View @extends Backbone.View
	return Backbone.View.extend({
		template: BRListrak_tpl,

		initialize: function (options) {
			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/
			// this.model = new BRListrakModel();
			// var self = this;
			// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
			// });
		},

		events: {},

		bindings: {},

		childViews: {},

		//@method getContext @return BRListrak.View.Context
		getContext: function getContext() {
			//@class BRListrak.View.Context
			this.message = this.message || 'Hello World!!';
			return {
				message: this.message
			};
		}
	});
});
